import PropTypes from 'prop-types';
import React from 'react';
import Text from 'shared/components/text';
import {withCommas} from 'shared/utils';

class EarningsText extends React.Component {
  static propTypes = {
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  };

  render() {
    const {amount} = this.props;

    return (
      <div className="shared-college-card-status-text-earnings">
        <span className="shared-college-card-status-text-subtext">
          <Text color="darkgrey" weight={6} inline>
            Currently earning
          </Text>
        </span>
        <Text weight={2} emphasis inline>
          ${withCommas(Math.round(amount))}
        </Text>
      </div>
    );
  }
}

export default EarningsText;
